module.exports = __webpack_public_path__ + "img/login-four.59f7bbe2.png";